(function() {

    'use strict';

    eclipseApp.controller('prepaidRefillOneTimeCtrl', ['$scope', '$rootScope', '$state', '$http', '$timeout', '$stateParams', '$previousState', '$sessionStorage', 'uteModal', 'uteLocale', 'httpService', 'prepaidAutoRefillInfoService', 'prepaidPlanInfoService', 'prepaidUserInfoService', 'prepaidRefillOneTimeService', 'prepaidRegisteredCCInfoService', 'prepaidRefillTaxCalculationService', 'prepaidAirtimeBalanceService', 'uteSemafoneService', 'util', 'retrievePrepaidPlanInfo', 'retrievePrepaidUserInfo', function($scope, $rootScope, $state, $http, $timeout, $stateParams, $previousState, $sessionStorage, uteModal, uteLocale, httpService, prepaidAutoRefillInfoService, prepaidPlanInfoService, prepaidUserInfoService, prepaidRefillOneTimeService, prepaidRegisteredCCInfoService, prepaidRefillTaxCalculationService, prepaidAirtimeBalanceService, uteSemafoneService, util, retrievePrepaidPlanInfo, retrievePrepaidUserInfo) {

        console.log('Inside prepaidRefillOneTimeCtrl');

        $scope.$extend({
            $storage : $sessionStorage,
            isOneTimeRefillReview: true,
            stopAutoPaymentNotifier: '',
            autoRefillSubscribed: 'false',
            selectedRefillAmount: null,
            language : uteLocale.language,
            refillAmount : '',
            totalAmount : '',
            GSTHSTAmount : '',
            PSTQSTAmount : '',
            InteracResponse : $stateParams.response,
            InteracEligibilityInfo : null,
            InteraPaymentInfo : null,
            refillAmountList : null,
            calculateTaxInfo : null,
            creditPaymentInfo : null,
            planAndAddOnInfo : null,
            InteracEligibilityError : null,
            InteracPaymentError : null,
            refillAmountListError : null,
            calculateTaxInfoError : null,
            creditPaymentInfoError : null,
            planAndAddOnInfoError : null,
            MERCHANT_NUMBER : null,
            IDEBIT_MERCHDATA : null,
            IDEBIT_INVOICE : null,
            IDEBIT_TERMID : null,
            INTERAC_SUCCESS_URL : null,
            INTERAC_FAILURE_URL : null,
            IDEBIT_AMOUNT : null,
            IDEBIT_MERCHLANG : null,
            planTitle : '',
            planFeatures : '',
            ctn : '',
            haveRegisteredCard : false,
            billingAddress : null,
            name : '',
            expiryDate : '',
            cardNumber : '',
            billingType: '',
            accountNumber: prepaidUserInfoService.getBAN(),

            fetchRefillAmountList: function() {
                //alert('checkInteracPaymentEligibility');
                var promise = httpService.send(
                    'v1/refill/autorefill/balance/amounts', // TODO : Need to change
                    {
                        accountNumber: $scope.accountNumber,
                        planSOC: prepaidPlanInfoService.getAirTimePlanSoc(),
                        autoMSFEligibility: prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.refillAmountListError = true;
                        } else {
                            //alert('Fetched RefillAmountList Successfully');
                            $scope.refillAmountList = result.data.rechargeAmounts;
                            $scope.selectedRefillAmount = $scope.refillAmountList[0];
                            if(prepaidRefillOneTimeService.getRefillValue() === '' || prepaidRefillOneTimeService.getRefillValue() === null){
                              prepaidRefillOneTimeService.setRefillValue($scope.selectedRefillAmount);
                            }else{
                              $scope.selectedRefillAmount.duration = prepaidRefillOneTimeService.getRefillValue().duration;
                              $scope.selectedRefillAmount.rechargeAmount = prepaidRefillOneTimeService.getRefillValue().rechargeAmount;
                            }
                            //alert('$scope.selectedRefillAmount :: duration :: '+$scope.selectedRefillAmount.duration);
                            //alert('$scope.selectedRefillAmount :: rechargeAmount :: '+$scope.selectedRefillAmount.rechargeAmount);
                        }
                    },
                    function(reason) {
                        $scope.refillAmountListError = true;
                    }
                );
            },

            updateRechargeAmount: function() {
                prepaidRefillOneTimeService.setRefillValue($scope.selectedRefillAmount);
                //alert(' On Change :: '+prepaidRefillOneTimeService.getRefillValue().rechargeAmount);
            },

            checkInteracPaymentEligibility: function() {
                //alert('checkInteracPaymentEligibility');
                //alert('checkInteracPaymentEligibility :: '+prepaidRefillOneTimeService.getRefillValue().rechargeAmount);
                //alert('billingType :: '+$scope.billingType);
                prepaidRefillOneTimeService.setBillingType($scope.billingType);
                $scope.$storage.selectedRefillAmount = prepaidRefillOneTimeService.getRefillValue();
                //alert('$scope.$storage.selectedRefillAmount :: fromCheck  '+$scope.$storage.selectedRefillAmount);
                var promise = httpService.send(
                    'v1/refill/interac/payment/eligibility/check', // TODO : Need to change
                    {
                        accountNumber: prepaidUserInfoService.getBAN(),
                        ctn: prepaidUserInfoService.getCTN(),
                        refillAmount: prepaidRefillOneTimeService.getRefillValue().rechargeAmount,
                        language: $scope.language
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.InteracEligibilityError = true;
                        } else {
                            //alert('Got AutoRefillEligibility Successfully');
                            $scope.InteracEligibilityInfo = result.data;
                            prepaidRefillOneTimeService.setInteracParameters($scope.InteracEligibilityInfo.interacParameters);
                            prepaidRefillTaxCalculationService.setRefillAmount($scope.InteracEligibilityInfo.refillAmount);
                            prepaidRefillTaxCalculationService.setTotal($scope.InteracEligibilityInfo.total);
                            prepaidRefillTaxCalculationService.setGST($scope.InteracEligibilityInfo.gsthst);
                            prepaidRefillTaxCalculationService.setHST($scope.InteracEligibilityInfo.gsthst);
                            prepaidRefillTaxCalculationService.setPST($scope.InteracEligibilityInfo.pstqst);
                            prepaidRefillTaxCalculationService.setQST($scope.InteracEligibilityInfo.pstqst);
                            $state.go('myAccount.prepaidRefill.oneTimeRefill.interac');
                        }
                    },
                    function(reason) {
                        $scope.InteracEligibilityError = true;
                    }
                );
            },

            redirectToInteracGateway: function() {
            $('#processing_submit_button').show();
            $('#pp-button-review').hide();
            $('#tryAgain_submit_button').hide();
                //alert('redirectToInteracGateway');
                //$('#formToRogers123').attr('action', 'https://merchant-test.interacidebit.ca/gateway/merchant_test_processor.do');
                $scope.$storage.selectedRefillAmount = prepaidRefillOneTimeService.getRefillValue();
                //alert('$scope.$storage.selectedRefillAmount :: '+$scope.$storage.selectedRefillAmount);
                $('#uteInteracForm').attr('action', prepaidRefillOneTimeService.getInteracParameters().INTERAC_URL); // jshint ignore:line
                $timeout(function() {
                    $('#uteInteracForm').submit();
                });
            },

            /*makeInteracPayment: function(accountNumber, subscriberNumber, language) {
                //alert('makeInteracPayment');
                var promise = httpService.send(
                    'wireless/prepaid/dashboard/refill/Interac/makePayment', // TODO : Need to change
                    {
                        ban: accountNumber,
                        ctn: subscriberNumber,
                        language: language
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.InteraPaymentError = true;
                        } else {
                            //alert('Got AutoRefillEligibility Successfully');
                            $scope.InteraPaymentInfo = result.data;
                        }
                    },
                    function(reason) {
                        $scope.InteraPaymentError = true;
                    }
                );
            },*/

            redirectToInteracErrorPage: function() {
                //alert('redirectToInteracErrorPage');
            },

            clearSharedPropertyService: function() {
                prepaidRefillOneTimeService.setRefillValue(null);
                prepaidRefillOneTimeService.setInteracParameters(null);
                prepaidRefillOneTimeService.setBillingType(null);
            },

            calculateTax: function() {
                prepaidRefillOneTimeService.setBillingType($scope.billingType);
                var promise = httpService.send(
                    'v1/refill/autorefill/tax/amount', {
                        accountNumber: $scope.accountNumber,
                        ctn: $scope.ctn,
                        refillAmount: prepaidRefillOneTimeService.getRefillValue().rechargeAmount,
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.calculateTaxInfoError = true;
                        } else {
                            $scope.calculateTaxInfo = result.data;
                            prepaidRefillTaxCalculationService.setRefillAmount($scope.selectedRefillAmount.rechargeAmount);
                            prepaidRefillTaxCalculationService.setGST($scope.calculateTaxInfo.gst);
                            prepaidRefillTaxCalculationService.setPST($scope.calculateTaxInfo.pst);
                            prepaidRefillTaxCalculationService.setTotal($scope.calculateTaxInfo.totalAmount);
                            prepaidRefillOneTimeService.setRefillValue($scope.selectedRefillAmount);
                            $state.go('myAccount.prepaidRefill.oneTimeRefill-review');
                        }
                    },
                    function(reason) {
                        $scope.calculateTaxInfoError = true;
                    }
                );
            },

           getPlanAndAddOnInfo : function (accountNumber, subscriberNumber, language) {
             var promise = httpService.send(
               'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
               {
               accountNumber: accountNumber,
               ctn: subscriberNumber,
               language: language
               });

             promise.then(
               function (result) {
                 if (result.data.error || result.data.status == 'Failed') {
                   $scope.planAndAddOnInfoError = true;
                 } else {
                   //alert('Got PlanAndAddOnInfo Successfully');
                   $scope.planAndAddOnInfo = result.data;
                   console.log('$scope.planAndAddOnInfo :: '+$scope.planAndAddOnInfo);
                   prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
                   prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
                   prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
                   $scope.pricePlanInfo = null;
                   if(result.data.planDetailsInfo != null){
                     if($scope.language === 'en' || $scope.language === 'EN'){
                       $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                     }else{
                       $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                     }
                     if(result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != ''){
                       prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                     }else{
                       prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                     }
                     if($scope.pricePlanInfo != null && $scope.pricePlanInfo.planComparison != null && $scope.pricePlanInfo.planComparison.planTitle != null && $scope.pricePlanInfo.planComparison.planTitle != ''){
                       prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                     }else{
                       if($scope.language === 'en' || $scope.language === 'EN'){
                         prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                       }else{
                         prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                       }
                     }
                   }else{
                      if($scope.language === 'en' || $scope.language === 'EN'){
                        prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                      }else{
                        prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                      }
                     prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                   }
                   $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
                   prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
                   $scope.isOneTimeRefillReview = false;
                   $scope.airtimeBalance = prepaidAirtimeBalanceService.getAirTimeBalance();
                   $scope.balanceExpiryDate = prepaidAirtimeBalanceService.getExpiryDate();
                   $scope.clearSharedPropertyService();
                 }
               },
               function (reason) {
                 $scope.planAndAddOnInfoError = true;
               }
             );
           },

            makeCreditPayment: function() {
            $('#processing_submit_button').show();
            $('#pp-button-review').hide();
            $('#tryAgain_submit_button').hide();
                $scope.isDisabled = true;
                var promise = httpService.send(
                    'v1/wireless/prepaid/creditcard/onetimepayment', {
                        accountNumber: $scope.accountNumber,
                        ctn: $scope.ctn,
                        refillAmount: $scope.refillAmount,
                        language: $scope.language
                    });

                promise.then(
                    function(result) {
                        if (result.data.error || result.data.status == 'Failed') {
                            $scope.creditPaymentInfoError = true;
                             $('#processing_submit_button').hide();
                            $('#pp-button-review').hide();
                            $('#tryAgain_submit_button').show();
                        } else {
                            //$scope.isOneTimeRefillReview = false;
                            $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
                        }
                        /*$scope.isOneTimeRefillReview = false;
                        $scope.airtimeBalance = prepaidAirtimeBalanceService.getAirTimeBalance();
                        $scope.balanceExpiryDate = prepaidAirtimeBalanceService.getExpiryDate();*/
                    },
                    function(reason) {
                        $scope.creditPaymentInfoError = true;
                        $('#processing_submit_button').hide();
                        $('#pp-button-review').hide();
                        $('#tryAgain_submit_button').show();
                    }
                );

            },
            cancelConfirm : function () {
              /*var modalConfig = {
                templateUrl: 'modules/my-account/prepaid/dashboard/refill/cancel-onetime-refill-confirm.html',
                controller: function ($scope, $modalInstance) {
                  $scope.ok = function () {
                    $modalInstance.close();
                  };
                  $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                  };
                },
                ok: function () {
                  $scope.clearSharedPropertyService();
                  $state.go('myAccount.prepaidRefill');
                },
                cancel: function () {

                }
              };*/
              // show modal
              //uteModal.open(modalConfig);
              uteModal.open({
                templateUrl: 'modules/my-account/prepaid/dashboard/refill/cancel-onetime-refill-confirm.html',
                /*controller: function ($scope, $modalInstance) {
                  $scope.ok = function () {
                    $modalInstance.close();
                  };
                  $scope.cancel = function () {
                    $modalInstance.dismiss('cancel');
                  };
                },*/
                ok: function () {
                  $scope.clearSharedPropertyService();
                  $state.go('myAccount.prepaidRefill');
                },
                cancel: function () {

                }
              });
            },
            backToDashboard : function () {
              $scope.clearSharedPropertyService();
              $state.go('myAccount.prepaidWLDashboard' , {'accountNumber': prepaidUserInfoService.getBAN(), 'subscriberNo': prepaidUserInfoService.getCTN()});
            },

            retrieveCreditCardRegistrationInfo : function () {
              var promise = httpService.send(
                'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
                {
                accountNumber: prepaidUserInfoService.getBAN(),
                ctn: prepaidUserInfoService.getCTN()
                });

              promise.then(
                function (result) {
                  if (result.data.error || result.data.status == 'Failed') {
                    $scope.creditCardRegistrationInfoError = true;
                    /*uncomment to toggle submit clickablity for credit card info error case */
                    //$scope.isDisabled = false;
                  } else {
                    //alert('Got userInfo Successfully');
                    $scope.creditCardRegistrationInfo = result.data;
                    if($scope.creditCardRegistrationInfo.registrationStatus){
                      //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                      prepaidRegisteredCCInfoService.setTokenizedCCNumber($scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo);
                      prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                      prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                    }
                    prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus($scope.creditCardRegistrationInfo.registrationStatus);
                  }
                },
                function (reason) {
                  $scope.creditCardRegistrationInfoError = true;
                }
              );
            },
            init: function() {
                if(prepaidUserInfoService.getCTN() === null || prepaidUserInfoService.getCTN() === '' || prepaidUserInfoService.getBAN() === null || prepaidUserInfoService.getBAN() === '') {
                  prepaidUserInfoService.setCTN($scope.$storage.selectedCTN);
                  prepaidUserInfoService.setBAN($scope.$storage.selectedBAN);
                }
                $scope.ctn = prepaidUserInfoService.getCTN();
                $scope.accountNumber = prepaidUserInfoService.getBAN();
                if((prepaidRefillOneTimeService.getInteracParameters() == '' || prepaidRefillOneTimeService.getInteracParameters() == null) && angular.isDefined($rootScope.currentState) && $rootScope.currentState.name !== '' && $rootScope.currentState.name !== null && $rootScope.currentState.name === 'myAccount.prepaidRefill.oneTimeRefill.interac'){
                  if(prepaidRefillOneTimeService.getRefillValue() == '' || prepaidRefillOneTimeService.getRefillValue() == null){
                    prepaidRefillOneTimeService.setRefillValue($scope.$storage.selectedRefillAmount);
                    $scope.refillValue = prepaidRefillOneTimeService.getRefillValue();
                  }
                  prepaidRefillOneTimeService.setBillingType('Interac');
                  var promise = httpService.send(
                    'v1/refill/interac/payment/eligibility/check', // TODO : Need to change
                    {
                      accountNumber: prepaidUserInfoService.getBAN(),
                      ctn: prepaidUserInfoService.getCTN(),
                      refillAmount: prepaidRefillOneTimeService.getRefillValue().rechargeAmount,
                      language: $scope.language
                    });

                  promise.then(
                    function(result) {
                      if (result.data.error || result.data.status == 'Failed') {
                        $scope.InteracEligibilityError = true;
                      } else {
                        //alert('Got AutoRefillEligibility Successfully');
                        $scope.InteracEligibilityInfo = result.data;
                        prepaidRefillOneTimeService.setInteracParameters($scope.InteracEligibilityInfo.interacParameters);
                        prepaidRefillTaxCalculationService.setRefillAmount($scope.InteracEligibilityInfo.refillAmount);
                        prepaidRefillTaxCalculationService.setTotal($scope.InteracEligibilityInfo.total);
                        prepaidRefillTaxCalculationService.setGST($scope.InteracEligibilityInfo.gsthst);
                        prepaidRefillTaxCalculationService.setHST($scope.InteracEligibilityInfo.gsthst);
                        prepaidRefillTaxCalculationService.setPST($scope.InteracEligibilityInfo.pstqst);
                        prepaidRefillTaxCalculationService.setQST($scope.InteracEligibilityInfo.pstqst);

                        if(prepaidRefillOneTimeService.getInteracParameters() != '' && prepaidRefillOneTimeService.getInteracParameters() != null) {
                          $scope.MERCHANT_NUMBER = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHNUM;
                          $scope.IDEBIT_MERCHDATA = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHDATA;
                          $scope.IDEBIT_INVOICE = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_INVOICE;
                          $scope.IDEBIT_TERMID = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_TERMID;
                          $scope.INTERAC_SUCCESS_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_FUNDEDURL;
                          $scope.INTERAC_FAILURE_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_NOTFUNDEDURL;
                          $scope.IDEBIT_MERCHLANG = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHLANG;
                          $scope.IDEBIT_AMOUNT = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_AMOUNT;
                        }
                        if(prepaidRefillTaxCalculationService.getRefillAmount() != '' && prepaidRefillTaxCalculationService.getRefillAmount() != null){
                          $scope.refillAmount = prepaidRefillTaxCalculationService.getRefillAmount();
                          $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
                          $scope.GSTHSTAmount = prepaidRefillTaxCalculationService.getGST();
                          $scope.PSTQSTAmount = prepaidRefillTaxCalculationService.getPST();
                        }
                      }
                    },
                    function(reason) {
                      $scope.InteracEligibilityError = true;
                    }
                  );
                }else {
                  if(prepaidRefillOneTimeService.getInteracParameters() != '' && prepaidRefillOneTimeService.getInteracParameters() != null) {
                    //alert('Inside Interac Parameters');
                    $scope.MERCHANT_NUMBER = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHNUM;
                    $scope.IDEBIT_MERCHDATA = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHDATA;
                    $scope.IDEBIT_INVOICE = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_INVOICE;
                    $scope.IDEBIT_TERMID = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_TERMID;
                    $scope.INTERAC_SUCCESS_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_FUNDEDURL;
                    $scope.INTERAC_FAILURE_URL = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_NOTFUNDEDURL;
                    $scope.IDEBIT_MERCHLANG = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_MERCHLANG;
                    $scope.IDEBIT_AMOUNT = prepaidRefillOneTimeService.getInteracParameters().IDEBIT_AMOUNT;
                  }
                  if(prepaidRefillTaxCalculationService.getRefillAmount() != '' && prepaidRefillTaxCalculationService.getRefillAmount() != null) {
                    $scope.refillAmount = prepaidRefillTaxCalculationService.getRefillAmount();
                    $scope.totalAmount = prepaidRefillTaxCalculationService.getTotal();
                    $scope.GSTHSTAmount = prepaidRefillTaxCalculationService.getGST();
                    $scope.PSTQSTAmount = prepaidRefillTaxCalculationService.getPST();
                  }

                  if(prepaidRefillOneTimeService.getRefillValue() != '' && prepaidRefillOneTimeService.getRefillValue() != null) {
                    $scope.refillValue = prepaidRefillOneTimeService.getRefillValue();
                  }
                }
                if($scope.InteracResponse === 'funded'){
                  //$scope.makeInteracPayment(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
                  //$scope.isOneTimeRefillReview = false;
                  //$scope.clearSharedPropertyService();
                  $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
                } else if($scope.InteracResponse === 'notFunded'){
                  $scope.redirectToInteracErrorPage();
                } else{
                  $scope.fetchRefillAmountList();
                }
                $scope.planTitle = prepaidPlanInfoService.getAirTimePlanTitle();
                $scope.planFeatures = prepaidPlanInfoService.getAirTimePlanFeatures();
                $scope.haveRegisteredCard = prepaidRegisteredCCInfoService.getCreditCardRegistrationStatus();
                $scope.billingAddress = prepaidUserInfoService.getBillingAddress();
                $scope.name = prepaidUserInfoService.getFirstName() + ' ' + prepaidUserInfoService.getLastName();
                if ($scope.haveRegisteredCard) {
                    $scope.expiryDate = prepaidRegisteredCCInfoService.getMonth();
                    $scope.cardNumber = prepaidRegisteredCCInfoService.getTokenizedCCNumber();
                }
                //alert('Before Coming from Review Page');
                //if(angular.isDefined($previousState.get().state.name) && $previousState.get().state.name !== '' && $previousState.get().state.name !== null && ($previousState.get().state.name === 'myAccount.prepaidRefill.oneTimeRefill.interac' || $previousState.get().state.name === 'myAccount.prepaidRefill.oneTimeRefill.interac-response' || $previousState.get().state.name === 'myAccount.prepaidRefill.oneTimeRefill-review' )){
                if(angular.isDefined($rootScope.previousState) && $rootScope.previousState.name !== '' && $rootScope.previousState.name !== null && ($rootScope.previousState.name === 'myAccount.prepaidRefill.oneTimeRefill.interac' || $rootScope.previousState.name === 'myAccount.prepaidRefill.oneTimeRefill.interac-response' || $rootScope.previousState.name === 'myAccount.prepaidRefill.oneTimeRefill-review' )){
                  //alert('Coming from Review Page');
                  $scope.billingType = prepaidRefillOneTimeService.getBillingType();
                }
            $('#processing_submit_button').hide();
            $('#tryAgain_submit_button').hide();
            }
        });

        $scope.isDisabled = false;
        $scope.today = new Date();
        $scope.firstMonth = 1;
        $scope.setRange = function(min, max) {
            var months = [];
            for (var i = min; i <= max; i++) months.push(i);
            return months;
        };
        $scope.payNowRule = {
            amount: {
                type: 'number',
                min: 0.01
            },
            ccNumber: {
                pattern: '((([0-9]{4}[ -]?){4})|(([0-9]{4}[ -]?)([0-9]{6}[ -]?)([0-9]{5})))'
            },
            expMonth: {
                type: 'number',
                min: 1,
                max: 12
            },
            expYear: {
                type: 'number',
                min: 2015,
                max: 2025
            },
            cvv: {
                type: 'text',
                minlength: 3,
                maxlength: 4,
                pattern: '^[0-9]{3,4}$'
            },
            ccName: {
                pattern: 'VISA|MASTER|AMEX'
            },
            ccTnc: {}
        };

        $scope.payNow = {};
        $scope.payment = {};
        var selfCardType = '';

        $scope.registerCreditCard = function(form) {
            util.validateFormOnSubmit(form);
            if (!form.$valid || ($scope.payNow.expYear == $scope.today.getFullYear() && $scope.payNow.expMonth <= $scope.today.getMonth())) {
                if (uteSemafoneService.getMaskedCardNumber() == null || uteSemafoneService.getMaskedCardNumber() == '') {
                    $scope.isNotValidCard = true;
                }
                return;
            }

            if (uteSemafoneService.getCardScheme() == 'VISA') {
                selfCardType = 'VISA';
            } else if (uteSemafoneService.getCardScheme() == 'AMEX') {
                selfCardType = 'AMEX';
            } else if (uteSemafoneService.getCardScheme() == 'MASTERCARD') {
                selfCardType = 'MASTERCARD';
            }

            var cvvLength = document.getElementById('cvv').value.length;
            $scope.maskedCardNumber = uteSemafoneService.getMaskedCardNumber();
            $scope.payment.maskedToken = uteSemafoneService.getToken();
            $scope.payment.ccType = uteSemafoneService.getCardScheme();

            if ($scope.payment.ccType == 'VISA') {
                $scope.cardType = 'ute-creditcards visa';
            }
            if ($scope.payment.ccType == 'AMEX') {
                $scope.cardType = 'ute-creditcards amex';
            }
            if ($scope.payment.ccType == 'MASTERCARD') {
                $scope.cardType = 'ute-creditcards master';
            }

            if ($scope.payment.maskedToken == null || $scope.payment.maskedToken == '') {
                $scope.isNotValidCard = true;
                //alert('The card number is invalid');
            } else {
                console.log('$scope.payment ready', $scope.payment);

            }
            prepaidRefillOneTimeService.setBillingType($scope.billingType);
            var promise = httpService.send(
                'v1/wireless/prepaid/creditcard/register', {
                    'CreditCardInfo.ccType': $scope.payment.ccType,
                    'CreditCardInfo.ccNumber': $scope.payment.maskedToken,
                    'CreditCardInfo.ccExpiryMonth': $scope.payNow.expMonth,
                    'CreditCardInfo.ccExpiryYear': $scope.payNow.expYear,
                    'CreditCardInfo.securityCode': $scope.payNow.cvv,
                    ctn: $scope.ctn,
                    accountNumber: $scope.accountNumber
                });

            promise.then(
                function(result) {
                    if (result.data.error || result.data.status == 'Failed') {
                        $scope.registerCardInfoError = true;
                    } else {
                        $scope.retrieveCreditCardRegistrationInfo();
                        $scope.calculateTax();
                    }
                },
                function(reason) {
                    $scope.registerCardInfoError = true;
                }
            );

        };

        /**
         *
         * @param state
         */
        $scope.go = function(state) {
            $state.go(state);
        };

        /**
         * tabs data for ui tabs directive
         * @type {{heading: string, subheading: string, route: string}[]}
         */

        $scope.tabData = [{
            heading: 'wireless.label.setUpAutoPayPlan',
            route: 'myAccount.prepaidRefill.autoPayPlan',
            autoRefillSubscribed: 'false',
            content: prepaidAutoRefillInfoService.getAutoPayPlanSubContent(),
            class: 'tab pp-refill-margin-top-1-5'
        }, {
            heading: 'wireless.label.setUpAutoRefillBalance',
            route: 'myAccount.prepaidRefill.autoRefillBalance',
            autoRefillSubscribed: 'false',
            content: prepaidAutoRefillInfoService.getAutoRefillBalanceSubContent(),
            class: 'tab pp-refill-margin-top-1-5'
        }, {
            heading: 'wireless.label.oneTimeRefill',
            route: 'myAccount.prepaidRefill.oneTimeRefill',
            autoRefillSubscribed: 'false',
            active: true,
            class: 'tab pp-refill-margin-top-1-5'

        }, {
            heading: 'wireless.label.redeemVoucher',
            route: 'myAccount.prepaidRefill.redeemVoucher',
            class: 'tab pp-refill-margin-top-1-5'
        }];

        $scope.mobileTabData = [{
            heading: 'wireless.label.oneTimeRefill',
            route: 'myAccount.prepaidRefill.oneTimeRefill',
            autoRefillSubscribed: 'false',
            active: true,
            class: 'tab pp-refill-margin-top-1-5'
        }];

        $scope.init();

    }]);

})();
